import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Game } from '../domain/game';

@Component({
  selector: 'app-remove-no-events-dialog',
  templateUrl: './remove-no-events-dialog.component.html',
  styleUrls: ['./remove-no-events-dialog.component.css']
})
export class RemoveNoEventsDialogComponent {
  teams = { home: true, away: true };
  game: Game;

  constructor(
    private dialogRef: MatDialogRef<RemoveNoEventsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.game = new Game(this.data?.game);
  }

  close(ok: boolean) {
    if (ok) {
      this.dialogRef.close({ teams: this.teams });
    } else {
      this.dialogRef.close();
    }
  }
}
